import { render, staticRenderFns } from "./MyteamdtlShimmer.vue?vue&type=template&id=dd0d9626&"
import script from "./MyteamdtlShimmer.vue?vue&type=script&lang=js&"
export * from "./MyteamdtlShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports